export default __webpack_public_path__ + "static/media/Cookies.0b1090b1.pdf";